import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  patchApiV2CustomersCustomerId,
  type PatchCustomerParams,
} from '@hungryroot/rest/api/v2/customers/[id]/patch';

/**
 * @deprecated
 *
 * This endppoint is deprecated because it invalidates all queries. We should be more precise about which queries to invalidate. See `useUpdateAccountDetails` for a better example.
 */
export function useUpdateCustomer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: PatchCustomerParams) => {
      const resp = await patchApiV2CustomersCustomerId(params);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    onSuccess() {
      // invalidate all queries because multiple endpoints read from
      // the customer table
      queryClient.invalidateQueries();
    },
  });
}
